import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';

import providerInstance from '@/services/provider';
import { IPaymentRequisitionLineData } from '@/models';

export function useUpdatePaymentRequisitionLine() {
  const { isLoading, isError, error, isSuccess, mutate, reset } = useMutation({
    mutationKey: ['update-payment-requisition'],
    mutationFn: ({
      id,
      line
    }: {
      id: number;
      line: IPaymentRequisitionLineData;
    }) =>
      providerInstance.paymentRequisition.updatePaymentRequisitionLine(id, line)
  });
  return {
    isLoading,
    isError,
    error,
    isSuccess,
    mutate,
    reset
  };
}
